// ตัวกรอง "แผนก" ของหน้ารายงานแจ้งเตือน (warranty-expiry / filter-alert / pm-alert)
//   - ตัวเลือก = แผนกจริงทีละแผนกจาก meta.department_options (ตามสิทธิ์ผู้ใช้) ส่ง department_uid ไป backend
//   - ลิงก์จากอีเมลแบบเก่า ?bu=BUxx ยังใช้ได้: เก็บไว้ใน filter_bu แล้วส่ง bu_code ตามเดิม
//     (แสดงเป็นตัวเลือกพิเศษ "BUxx" ใน dropdown จนกว่าผู้ใช้จะเลือกแผนกอื่น/ล้างตัวกรอง)
//   - ลิงก์ใหม่ ?department_uid=<uid> กรองแผนกนั้นโดยตรง (มีก่อน ?bu)
const BU_PATTERN = /^BU\d{2}$/;
const BU_OPTION_PREFIX = "bu:";

/** อ่านค่าเริ่มต้นจาก query string · allowedBus = จำกัด BU ที่รับ (ไม่ส่ง = BU01-BU99) */
export const readDepartmentFilter = (query, allowedBus = null) => {
  const departmentUid = String(query.get("department_uid") || "").trim();
  if (departmentUid) return { filter_department_uid: departmentUid, filter_bu: "" };
  const bu = String(query.get("bu") || "").trim().toUpperCase();
  const ok = allowedBus ? allowedBus.includes(bu) : BU_PATTERN.test(bu);
  return { filter_department_uid: "", filter_bu: ok ? bu : "" };
};

export const departmentLabel = (d) => [d.code, d.name].filter(Boolean).join(" ");

/** options ของ Select · allLabel = ตัวเลือกแรก (ทุกแผนกที่มีสิทธิ์) */
export const departmentFilterOptions = (meta, filterBu, allLabel) => [
  { value: "", label: allLabel },
  ...(filterBu ? [{ value: `${BU_OPTION_PREFIX}${filterBu}`, label: filterBu }] : []),
  ...(meta?.department_options || []).map((d) => ({ value: d.uid, label: departmentLabel(d) })),
];

export const departmentFilterValue = (state) =>
  state.filter_department_uid || (state.filter_bu ? `${BU_OPTION_PREFIX}${state.filter_bu}` : "");

/** แปลงค่าที่เลือกใน Select เป็น patch ของ state */
export const departmentFilterPatch = (value) => {
  const v = String(value || "");
  if (v.startsWith(BU_OPTION_PREFIX)) return { filter_bu: v.slice(BU_OPTION_PREFIX.length), filter_department_uid: "" };
  return { filter_bu: "", filter_department_uid: v };
};

export const EMPTY_DEPARTMENT_FILTER = Object.freeze({ filter_bu: "", filter_department_uid: "" });
